import React, { FC } from 'react';
import { ServicePagesProps } from './ServicePagesProps';
import LinkList, { LinkListItem } from '@ingka/link-list';
import Box from '@mui/material/Box';

const ServicePages: FC<ServicePagesProps> = ({ settingsList }) => {
  return (
    <Box
      sx={{
        mt: -2,
        '& .link-list--compact': {
          '& .link-list__list li:first-child a': {
            paddingTop: 0,
            borderTop: 'none',
          },
          '& .link-list__item': {
            padding: '0.8rem 0',
          },
        },
      }}
    >
      <LinkList compact label={null}>
        {settingsList.map((setting) => (
          <LinkListItem {...setting} key={setting.href} />
        ))}
      </LinkList>
    </Box>
  );
};

export default ServicePages;
